/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { chipColorDecisionMaker } from "../../../utils/chipColorDecisionMaker";
import {
  productSelector,
  setProductTabValue,
} from "../../../../../redux/slices/productSlice";
import { useDispatch, useSelector } from "react-redux";
import ProductReviewCard from "./ProductReviewCard";
import { useState } from "react";
import { useEffect } from "react";
import { getProduct } from "../../../../../api/product";
import NotFound from "../../../../../components/NotFound";
import { Link, useLocation } from "react-router-dom";
import NoProductFound from "../../../../../assets/img/products.png";
import { Pagination, Stack } from "@mui/material";
import ColoredMenuSVG from "../../../../../components/ColoredMenuSVG";
import useWindowWidth from "../../../../../hooks/useWindowWidth";
import globalStyles from "../../../../../styles/globalStyles.module.css";
import NewNotFound from "../../../components/NewNotFound";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Tab value -> product status the server filters on.
const TAB_STATUS = { 0: "pending", 1: "accepted", 2: "requote", 3: "failed", 4: "quality_requote" };

export default function ProductSourceReviewTab({
  sortByOption,
  marginTop,
  height,
  overflow,
  storeOwner,
}) {
  const { productInfo, productTabValue } = useSelector(productSelector);
  const [value, setValue] = React.useState(productTabValue);
  const dataFetchedRef = React.useRef(false);
  const [sortedProducts, setSortedProducts] = useState([]);
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(
      getProduct({
        page: newPage - 1,
        size: 50,
        status: TAB_STATUS[value] || "pending",
      })
    );
  };

  useEffect(() => {
    setSortedProducts(productInfo?.products);
  }, [productInfo]);
  useEffect(() => {
    // eslint-disable-next-line default-case
    switch (sortByOption) {
      // case 1: //Price low - high
      //   break;
      // case 2: //Price high - low
      //   break;
      case 3: //Product name A - Z
        setSortedProducts(
          [...sortedProducts]?.sort((a, b) => a.title.localeCompare(b.title))
        );
        break;
      case 4: //Product name Z - A
        setSortedProducts(
          [...sortedProducts]?.sort((a, b) => b.title.localeCompare(a.title))
        );
        break;
      case 5: //Creation date new - old
        setSortedProducts(
          [...sortedProducts]?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )
        );
        break;
      case 6: //Creation date old - new
        setSortedProducts(
          [...sortedProducts]?.sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
          )
        );
        break;
      // default:
    }
  }, [sortByOption]);

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    if (!storeOwner) {
      dispatch(
        getProduct({
          page: 0,
          size: 50,
          status: TAB_STATUS[productTabValue] || "pending",
        })
      );
    }
  }, [dispatch, productTabValue]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const location = useLocation().pathname;
  const windowWidth = useWindowWidth();

  const productsLocation = location === "/customer/dashboard";

  const tabChipStyle = productsLocation && {
    width: "20px",
    height: "16px",
    fontSize: "8px",
  };

  const tabStyle = productsLocation && {
    "& .MuiTab-root": {
      fontSize: windowWidth <= 1500 ? "10px" : "11px",
    },
  };

  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const color1 = isHovered ? "#8D40FF" : "#231f20"; // Change color1 based on hover state
  const color2 = isHovered ? "#fff" : "#c5c4c6";

  return (
    <Box
      sx={{
        paddingBottom: "10px",
        width: "100%",
        marginTop: marginTop ? marginTop : "20px",
        // paddingRight: "30px",
        background: "#fff",
        borderRadius: "10px",
        boxShadow:
          " 0px 2px 2px rgb(145 158 171 / 20%), 0px 12px 24px -4px rgb(145 158 171 / 12%)",
        ".MuiTabs-flexContainer": {
          borderRadius:
            location !== "/customer/dashboard" && "0 0 0 0 !important",
        },
        zIndex: 999,
      }}
    >
      <Box>
        <Tabs
          value={value}
          sx={{
            position: "relative",
            zIndex: 1,
            "& .Mui-Selected": {
              color: "red",
            },
            ".MuiTabs-flexContainer": {
              background: "#eee!important",
            },
            ...tabStyle,
          }}
          onChange={handleChange}
          aria-label="basic tabs example"
          inkBarStyle={{ backgroundColor: "#000" }}
        >
          <Tab
            onClick={() => {
              dispatch(setProductTabValue(0));
              dispatch(getProduct({ status: "pending" }));
            }}
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 0 && "700",
                }}
              >
                {chipColorDecisionMaker(
                  "pending",
                  productInfo?.totalUnquotedProducts,
                  false,
                  tabChipStyle
                )}
                Unquoted
              </div>
            }
            value={0}
            {...a11yProps(0)}
          />
          <Tab
            onClick={() => {
              dispatch(setProductTabValue(1));
              dispatch(getProduct({ status: "accepted" }));
            }}
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 1 && "700",
                }}
              >
                {chipColorDecisionMaker(
                  "accepted",
                  productInfo?.totalQuotedProducts,
                  false,
                  tabChipStyle
                )}
                Quoted
              </div>
            }
            value={1}
            {...a11yProps(1)}
          />
          {productInfo?.totalRequoteProducts > 0 && !productsLocation && (
            <Tab
              onClick={() => {
                dispatch(setProductTabValue(2));
                dispatch(getProduct({ status: "requote" }));
              }}
              label={
                <div
                  style={{
                    display: "flex",
                    fontWeight: value === 2 && "700",
                  }}
                >
                  {chipColorDecisionMaker(
                    "requote",
                    productInfo?.totalRequoteProducts,
                    false,
                    tabChipStyle
                  )}
                  Additional Requests
                </div>
              }
              value={2}
              {...a11yProps(2)}
            />
          )}
          {productInfo?.totalQualityRequoteProducts > 0 && !productsLocation && (
            <Tab
              onClick={() => {
                dispatch(setProductTabValue(4));
                dispatch(getProduct({ status: "quality_requote" }));
              }}
              label={
                <div
                  style={{
                    display: "flex",
                    fontWeight: value === 4 && "700",
                  }}
                >
                  {chipColorDecisionMaker(
                    "requote",
                    productInfo?.totalQualityRequoteProducts,
                    false,
                    tabChipStyle
                  )}
                  Re-quotes
                </div>
              }
              value={4}
              {...a11yProps(4)}
            />
          )}
          <Tab
            onClick={() => {
              dispatch(setProductTabValue(3));
              dispatch(getProduct({ status: "failed" }));
            }}
            label={
              <div
                style={{
                  display: "flex",
                  fontWeight: value === 3 && "700",
                }}
              >
                {chipColorDecisionMaker(
                  "failed",
                  productInfo?.totalFailedProducts,
                  false,
                  tabChipStyle
                )}
                Failed
              </div>
            }
            value={3}
            {...a11yProps(3)}
          />

          {location === "/customer/dashboard" && (
            <>
              <div
                style={{ position: "absolute", zIndex: 3, right: 13, top: 14 }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link to="/customer/products">
                  <ColoredMenuSVG
                    text="products"
                    color={color1}
                    color2={color2}
                  />
                </Link>
              </div>
            </>
          )}
        </Tabs>
      </Box>
      <TabPanel
        value={value}
        index={0}
        className="hide_scrollbar"
        style={{
          height: height ? height : "auto",
          overflowY: overflow ? overflow : "auto",
        }}
      >
        {!storeOwner && (
          <ProductReviewCard
            products={sortedProducts || []}
            content="quoted"
            totalProduct={productInfo?.totalUnquotedProducts}
            status={1}
          />
        )}
        {storeOwner ? (
          <NewNotFound
            title="No products found"
            width="250"
            img={NoProductFound}
            subTitle="You currently have no unquoted products"
          />
        ) : (
          productInfo?.totalUnquotedProducts < 1 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: productsLocation ? "417px" : "450px",
                justifyContent: "center",
                background: "white",
              }}
            >
              {productsLocation ? (
                <NewNotFound
                  title="No products found"
                  width="250"
                  img={NoProductFound}
                  subTitle="You currently have no unquoted products"
                />
              ) : (
                <NotFound
                  margin="4%"
                  content="products"
                  subContent="You have no products waiting for a quote."
                />
              )}
            </div>
          )
        )}
      </TabPanel>
      <TabPanel
        className="hide_scrollbar"
        value={value}
        index={1}
        style={{
          height: height ? height : "auto",
          overflowY: overflow ? overflow : "auto",
        }}
      >
        <ProductReviewCard
          products={sortedProducts || []}
          content="quoted"
          totalProduct={productInfo?.totalQuotedProducts}
          status={1}
        />
        {productInfo?.totalQuotedProducts < 1 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: productsLocation ? "417px" : "450px",
              justifyContent: "center",
              background: "white",
            }}
          >
            {productsLocation ? (
              <NewNotFound
                title="No products found"
                width="250"
                img={NoProductFound}
                subTitle="You currently have no quoted products"
              />
            ) : (
              <NotFound
                margin="4%"
                content="products"
                subContent="No products have a quote yet."
              />
            )}
          </div>
        )}
      </TabPanel>
      <TabPanel
        value={value}
        index={2}
        className="hide_scrollbar"
        style={{
          height: height ? height : "auto",
          overflowY: overflow ? overflow : "auto",
        }}
      >
        <ProductReviewCard
          products={sortedProducts || []}
          content="requote"
          totalProduct={productInfo?.totalRequoteProducts}
          status={1}
        />
        {productInfo?.totalRequoteProducts < 1 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: productsLocation ? "417px" : "450px",
              justifyContent: "center",
              background: "white",
            }}
          >
            {productsLocation ? (
              <NewNotFound
                title="No products found"
                width="250"
                img={NoProductFound}
                subTitle="You currently don't have any failed products"
              />
            ) : (
              <NotFound
                margin="4%"
                content="products"
                subContent="You have no open additional requests."
              />
            )}
          </div>
        )}
      </TabPanel>
      <TabPanel
        value={value}
        index={4}
        className="hide_scrollbar"
        style={{
          height: height ? height : "auto",
          overflowY: overflow ? overflow : "auto",
        }}
      >
        <ProductReviewCard
          products={sortedProducts || []}
          content="requote"
          totalProduct={productInfo?.totalQualityRequoteProducts}
          status={1}
        />
        {!(productInfo?.totalQualityRequoteProducts > 0) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "450px",
              justifyContent: "center",
              background: "white",
            }}
          >
            <NotFound margin="4%" content="products" subContent="You have no open re-quote requests." />
          </div>
        )}
      </TabPanel>
      <TabPanel
        value={value}
        index={3}
        className="hide_scrollbar"
        style={{
          height: height ? height : "auto",
          overflowY: overflow ? overflow : "auto",
        }}
      >
        <ProductReviewCard
          products={sortedProducts || []}
          content="failed"
          totalProduct={productInfo?.totalFailedProducts}
          status={1}
        />
        {productInfo?.totalFailedProducts < 1 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: productsLocation ? "417px" : "450px",
              justifyContent: "center",
              background: "white",
            }}
          >
            {productsLocation ? (
              <NewNotFound
                title="No products found"
                width="250"
                img={NoProductFound}
                subTitle="You currently have no failed products"
              />
            ) : (
              <NotFound
                margin="4%"
                content="products"
                subContent="You have no failed products."
              />
            )}
          </div>
        )}
      </TabPanel>
      {productsLocation && sortedProducts?.length > 0 ? (
        <div style={{ textAlign: "center", marginTop: 10 }}>
          <Link to="/customer/products">View more</Link>
        </div>
      ) : (
        <div
          style={{ textAlign: "center", paddingTop: 10, background: "white" }}
        >
          <Link to="/customer/products" style={{ visibility: "hidden" }}>
            View more
          </Link>
        </div>
      )}

      {!productsLocation && !storeOwner && sortedProducts?.length > 0 && (
        <div
          style={{
            bottom: 10,
            left: "45%",
            padding: "5px 0",
            marginTop: "40px",
          }}
          className={`${globalStyles.justify_center} ${globalStyles.br_8}`}
        >
          <Stack
            spacing={2}
            sx={{
              backgroundColor: "#fff",
              boxShadow:
                "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px",
              padding: "3px 10px",
              borderRadius: "5px",
            }}
          >
            {/* <TablesPagination /> */}

            <Pagination
              onChange={handleChangePage}
              sx={{
                ".MuiPagination-root": {
                  ".Mui-selected": {
                    backgroundColor: "#8D40FF",
                    color: "#fff",
                  },
                },
              }}
              defaultPage={page || 1}
              count={Math.ceil(
                value === 0
                  ? productInfo?.totalUnquotedProducts / 50
                  : value === 1
                  ? productInfo?.totalQuotedProducts / 50
                  : value === 2
                  ? productInfo?.totalRequoteProducts / 50
                  : value === 4
                  ? productInfo?.totalQualityRequoteProducts / 50
                  : productInfo?.totalFailedProducts / 50
              )}
              shape="rounded"
            />
          </Stack>
        </div>
      )}
    </Box>
  );
}
